import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import islands from '@constants/islands'
import { OPENMAPFIELDS } from '@modules/open-street-map-field'
import toastr from '@modules/toastr'
import Swal from 'sweetalert2'


export default class BuildingPermit extends React.Component {
  resource = '/building_regulations_acts'
  form_key = 'building_regulations_act'
  isRenewal = this.props.location.pathname.includes('-renewal')

  defaults = {
    renewal: this.isRenewal,
    // transfer: this.isTransfer
  }

  read_params = {
    admin: true,
    label: ' ',
    default: 'Default',
    values: {
      'Default': {
        renewal: this.isRenewal,
        // transfer: this.isTransfer,
      },
    },
  }

  coordinates = null
  
  // Delete lines as needed
  // fee = 99
  free = true
  postpaid = false
  skip_location = true
  hide_buttons  = {
    status: true,
    deny: false,
    approve: true,
  }
  custom_actions = [
    // {
    //   text: 'Confirm Appointment Date',
    //   icon: 'chevron-right',
    //   roles: [['inspector']],
    //   test: r => ['pending', 'processing'].includes(r.application_decision),
    //   fn: async record => this.setState({ record })
    // },

    {
      text: 'Set Initial Deposit',
      icon: 'chevron-right',
      roles: [['officer']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => (async () => {
        const confirmBox = await Swal.fire({
          icon: 'question',
          title: 'Set Initial Deposit',
          html: `
            What is the downpayment for this application?
          `,
          input: 'number',
          showCancelButton: true,
          confirmButtonText: 'Send',
        })
  
        if (confirmBox.isDismissed) return
        const deposit = confirmBox.value

        toastr.success('Success', 'Application successfully updated')
        console.log('Deposit:', deposit)
      })()
    },

    {
      text: 'Process Application',
      icon: 'bullhorn',
      roles: ['senior_officer'],
      test: r => r.application_decision == 'pending' || r.application_decision == 'processing',
      fn: async record => (async () => {
        const allAgencies = {
          'AMMC': 'AMMC',
          'DL&S': 'DL&S',
          'Port Department': 'Port Department',
          'DEPP': 'DEPP',
          'BCAA': 'BCAA',
          'Ministry Of Agriculture': 'Ministry Of Agriculture',
          'P.E.U': 'P.E.U',
          'ROADS': 'ROADS',
          'MOH': 'Ministry of Housing (MOH)',
          'TPD': 'TPD',
          'DEHS': 'DEHS',
          'Fire Department': 'Fire Department',
          'ABCO (M&VS)': 'ABCO (M&VS)',
          'ABCO (E&E)': 'ABCO (E&E)',
          'LICENSING': 'LICENCING',
          'STRUCTURES': 'STRUCTURES',
          'ABCO (B)': 'ABCO (B)',
          'BCO': 'BCO',
        }

        const confirmBox = await Swal.fire({
          icon: 'question',
          title: 'Select Agency/Section',
          html: `
            Select which agency this application is going to be referred to.
          `,
          input: 'select',
          inputOptions: allAgencies,
          showCancelButton: true,
          confirmButtonText: 'Send',
        })
  
        if (confirmBox.isDismissed) return
        const sectionSelected = confirmBox.value

        toastr.success('Success', 'Application successfully updated')
        console.log('Section Selected:', sectionSelected)
      })()
    },
  ]

  validate = async form => {
    const update = {}

    // Allow map component selected coordinates to translate to form latitude and longitude fields
    if(this.coordinates) {
      update.latitude = this.coordinates[0]
      update.longitude = this.coordinates[1]
    }

    // Handle other option in construction_type_list
    const constructionTypeList = form.construction_type_list_ghost.filter(x => x != 'Other')
    if (form.construction_type_list_ghost.includes('Other')) {
      const otherList = form.other_construction_type_list.map(x => x.permit_type)
      const mergedList = constructionTypeList.concat(otherList);
      // const objectList = mergedList.map(x => ({ permit_type: x }));
      // console.log(constructionTypeList);
      // console.log(otherList);
      // console.log(mergedList);
      // console.log(objectList);

      update.construction_type_list =  mergedList
    } else {
      update.construction_type_list =  constructionTypeList
    }

    console.log('Update:', update)
    return update
  }

  foremost = null

  fields = (form, formRef) => [
    {
      name: 'renewal',
      hide: true,
      save: true,
    },
    {
      name: 'construction_type_list',
      label: 'Building Permit Type',
      hint: 'Select all that apply',
      columns: ['permit_type'],
      view: {
        format: list => list.map(row => ({permit_type: row}))
      },
      save: true,
      hide: true,
    },
    {
      name: 'construction_type_list_ghost',
      label: 'Building Permit Type',
      hint: 'Select all that apply',
      multi: true,
      view: false,
      options: ['Apartments', 'Building Additions', 'Commercial Buildings', 'Pool', 'Renovations',
        'Residence', 'Walls', 'Demolition', 'Tents', 'Solar', 'Docks', 'Signs', 'Other']
    },
    {
      name: 'other_construction_type_list',
      label: 'Other Building Permit Type',
      columns: ['permit_type'],
      hide: !form.construction_type_list_ghost?.includes('Other'),
      view: false
    },
    // {
    //   name: 'walls_materials_list',
    //   label: 'List materials needed for the walls.',
    //   columns: ['wall'],
    //   format: v => v.wall,
    // },
    {
      name: 'island',
      options: islands,
    },
    {
      name: 'building_square_ft',
      label: 'Building Square Feet',
      type: 'integer',
    },
    {
      name: 'property_type',
      label: 'Property Type',
      options: ['Residential', 'Commercial']
    },
    {
      name: 'building_permit_numb',
      label: 'Buidling Permit Number',
      hide: true,
      required: false,
    },
    // {
    //   name: 'area',
    // },
    // {
    //   name: 'drawings_numb',
    //   label: 'Number of drawings',
    //   type: 'integer',
    // },
    {
      name: 'i_am_delegate',
      label: 'I am a delegate',
      type: 'select:bool',
    },
    {
      name: 'i_am',
      label: 'I am the...',
      options: ['owner', 'leasee', 'agent']
    },
    {
      name: 'delegate_profession',
      label: 'Profession',
    },

    '::Applicant information',
    {
      name: 'applicant_first_name',
      label: 'First Name',
      hide: !form.i_am_delegate,
    },
    {
      name: 'applicant_middle_name',
      label: 'Middle Name',
      hide: !form.i_am_delegate,
      required: false,
    },
    {
      name: 'applicant_last_name',
      label: 'Last Name',
      hide: !form.i_am_delegate,
    },
    {
      name: 'applicant_street_address',
      label: 'Address',
      type: 'textarea',
      hide: !form.i_am_delegate,
    },
    {
      name: 'applicant_island',
      label: 'Island',
      options: islands,
      hide: !form.i_am_delegate,
    },
    {
      name: 'applicant_phone',
      label: 'Phone Number',
      type: 'phone',
      hide: !form.i_am_delegate,
    },
    {
      name: 'applicant_email',
      label: 'Email Address',
      type: 'email',
      hide: !form.i_am_delegate,
    },
    {
      name: 'building_contractor',
      required: false,
    },

    '::Interest in Land',
    {
      name: 'interest_in_land',
      label: 'What is the intended use of this land?',
      // type: 'textarea',
      options: ['Apartments', 'Building Additions', 'Commercial Buildings', 'Pool', 'Renovations',
        'Residence', 'Walls', 'Demolition']
    },
    {
      name: 'development_consent',
      label:
        'Has consent been given to begin development on this land/building?',
      type: 'select:bool',
    },
    {
      name: 'land_address',
      label: 'Address of Land',
      type: 'textarea',
      hint: 'Be very decriptive',
    },
    {
      name: 'land_lot_number',
      label: 'Lot number',
      required: true,
    },
    {
      name: 'block_numb',
      label: 'Block number',
      required: false,
    },
    {
      name: 'land_building_number',
      label: 'Building number',
      required: false,
    },
    {
      name: 'land_subdivision',
      label: 'Subdivision',
      required: false,
    },

    ...OPENMAPFIELDS(this, form, formRef, null),

    '::Proposed Development Details',
    // {
    //   name: 'b_c',
    //   label: 'B.C.',
    //   type: 'select:bool',
    //   required: false,
    // },
    // {
    //   name: 'w_c',
    //   label: 'W.C.',
    //   type: 'select:bool',
    //   required: false,
    // },
    {
      name: 'proposed_development_details',
      label: 'How do you intend to use the land/building?',
      type: 'textarea',
      hint: 'If you intend to use it for more than one purpose, explain',
    },
    {
      name: 'current_land_use_desc',
      label: 'What is the land/building currently being used for?',
      type: 'textarea',
    },

    '::Materials For Exterior Finish of the Buildings',
    {
      name: 'walls_materials_list',
      label: 'List materials needed for the walls.',
      columns: ['wall'],
      format: v => v.wall,
    },
    {
      name: 'roofing_materials_list',
      label: 'List materials needed for the roof.',
      columns: ['roof'],
      format: v => v.roof,
    },
    {
      name: 'total_area',
      label: 'What is the total area?',
      type: 'integer',
      hint: 'In square feet or lineal feet',
    },
    {
      name: 'estimated_cost',
      label: 'What is the estimated cost',
      is: 'currency',
    },

    '::Architect Details',
    {
      name: 'architect_first_name',
      label: 'First Name',
    },
    {
      name: 'architect_middle_name',
      label: 'Middle Name',
      required: false,
    },
    {
      name: 'architect_last_name',
      label: 'Last Name',
    },
    {
      name: 'architect_island',
      label: 'Island',
      options: islands,
    },
    {
      name: 'architect_street_address',
      label: 'Address',
    },
    {
      name: 'architect_phone',
      label: 'Phone Number',
      type: 'phone',
    },
    {
      name: 'architect_email',
      label: 'Email Address',
    },

    {
      name: 'surveyor',
      label: 'Is there a Surveyor?',
      type: 'select:bool',
    },

    '::Surveyor Details',
    {
      name: 'surveyor_first_name',
      label: 'First Name',
      hide: !form.surveyor,
    },
    {
      name: 'surveyor_middle_name',
      label: 'Middle Name',
      hide: !form.surveyor,
      required: false,
    },
    {
      name: 'surveyor_last_name',
      label: 'Last Name',
      hide: !form.surveyor,
    },
    {
      name: 'surveyor_island',
      label: 'Island',
      options: islands,
      hide: !form.surveyor,
    },
    {
      name: 'surveyor_address',
      label: 'Address',
      hide: !form.surveyor,
    },
    {
      name: 'surveyor_phone',
      label: 'Phone Number',
      type: 'phone',
      hide: !form.surveyor,
    },
    {
      name: 'surveyor_email',
      label: 'Email Address',
      hide: !form.surveyor,
    },

    '::Required Documents',
    {
      name: 'location_plan_upload',
      label: 'Location plan',
      key: 'image.1',
      type: 'file:all',
    },
    {
      name: 'site_plans_upload',
      label: 'Site plan',
      key: 'image.3',
      type: 'file:all',
      hide: this.isRenewal,
    },
    {
      name: 'architect_drawings_upload',
      label: 'Architect Drawings',
      key: 'image.4',
      type: 'file:all',
    },
    {
      name: 'survey_upload',
      label: 'Survey',
      key: 'image.2',
      type: 'file:all',
      requried: false,
    },
    {
      name: 'structural_drawings_upload',
      label: 'Structural Drawings',
      key: 'image.5',
      type: 'file:all',
      requried: false,
    },
    {
      name: 'garage_drawings_upload',
      label: 'Garage Drawings',
      key: 'image.6',
      type: 'file:all',
      hide: form.property_type == 'Residential',
      required: false,
    },
    {
      name: 'mechanical_drawings_upload',
      label: 'Mechanical Drawings',
      key: 'image.7',
      type: 'file:all',
      required: false,
    },
    {
      name: 'electrical_drawings_upload',
      label: 'Electrical Drawings',
      key: 'image.8',
      type: 'file:all',
      requried: false,
    },
    {
      name: 'plumbing_drawings_upload',
      label: 'Plumbing Drawings',
      key: 'image.9',
      type: 'file:all',
      requried: false,
    },
    {
      name: 'volatile_drawings_upload',
      label: 'Volatile Drawings',
      key: 'image.10',
      type: 'file:all',
      hide: form.property_type == 'Residential',
      requried: false,
    },
    {
      name: 'sprinkler_drawings_upload',
      label: 'Fire Sprinkler Drawings',
      key: 'image.16',
      type: 'file:all',
      requried: false,
    },
    {
      name: 'fire_alarm_drawings_upload',
      label: 'Fire Alarm Drawings',
      key: 'image.17',
      type: 'file:all',
      requried: false,
    },
    {
      name: 'elevator_drawings_upload',
      label: 'Elevator Drawings',
      key: 'image.11',
      type: 'file:all',
      required: false,
    },
    {
      name: 'disability_upload',
      label: 'Disability Accessibility (ADA) Compliance',
      key: 'image.12',
      type: 'file:all',
      hide: form.property_type == 'Residential',
      required: false,
    },
    {
      name: 'approval_letter_upload',
      label: 'Approval letter',
      key: 'image.13',
      type: 'file:all',
      required: false,
    },
    {
      name: 'homeowners_upload',
      label: 'Homeowners Association Documents',
      key: 'image.14',
      type: 'file:all',
      required: false,
    },
    {
      name: 'family_island_upload',
      label: 'Family Island Administrator Documents',
      key: 'image.15',
      type: 'file:all',
      required: false,
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
